"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGateway = exports.initApex = exports.getApex = exports["default"] = void 0;
var _alphapointApexApi = require("alphapoint-apex-api");
var apex = {
  connection: {},
  gateway: ''
};
var setGateway = exports.setGateway = function setGateway(gateway) {
  apex.gateway = gateway;
  apex.connection = {};
};
var initApex = exports.initApex = function initApex(onopen, onclose) {
  var gateway = apex.gateway;
  apex.connection = new _alphapointApexApi.APEX(gateway, {
    onopen: onopen,
    onclose: onclose
  });
  apex.connection.standardCallback = function () {};
};
var getApex = exports.getApex = function getApex() {
  var onopen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var onclose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  if (!apex.connection.ws) {
    var server;
    var cookie = localStorage.getItem('tradingServer');
    if (apex.gateway) server = apex.gateway;
    if (cookie) server = cookie;
    if (!server) {
      // t("Gateway not selected")
      throw new Error('Gateway not selected');
    }
    setGateway(server);
    initApex(onopen, onclose);
  }
  return apex;
};
var _default = exports["default"] = apex;